import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import TituloAdmin from '@components/TituloAdmin';
import BotonBuscar from '@components/BotonBuscar';
import LoadingOverlay from '@components/LoadingOverlay';
import LabelCarga from '@components/LabelCarga';
import { getAllServiciosApi, updateServicioApi } from "@api/wp/administracion/servicios/serviciosApi";

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorAdminStyle } from '@styles/cajaContenedorAdmin';

import { getAllEmpresasApi } from "@api/wp/empresas/empresasApi";
import { viewEspecialidadesGroupApi } from "@api/wp/especialidades/especialidadesApi";
import { colors } from '@styles/colors';
import { selectStyle } from '@styles/selecsEstylos';
import Label from '@components/Label';
import '@styles/select2Custom.css';
import '@styles/modernTable.css';


function Serviciosadmin() {
  const navigate = useNavigate();
  const [servicios, setServicios] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [procesando, setProcesando] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const filtroEmpresaRef = useRef('');
  const filtroEspecialidadNombreRef = useRef('');
  const empresaFiltroSelectRef = useRef(null);
  const especialidadFiltroSelectRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  // Select2 — mismo criterio que CitasExtras.jsx
  useEffect(() => {
    try {
      const $ = window.$;
      if (!empresaFiltroSelectRef.current || !$?.fn?.select2) {
        return undefined;
      }
      const $el = $(empresaFiltroSelectRef.current);
      if ($el.hasClass('select2-hidden-accessible')) {
        $el.off('change.select2react');
        $el.select2('destroy');
      }
      $el.select2({
        placeholder: '-- Seleccione una empresa --',
        allowClear: true,
        width: '100%',
        theme: 'default',
        minimumResultsForSearch: 0,
        language: {
          noResults: function () { return 'No se encontraron resultados'; },
          searching: function () { return 'Buscando...'; },
        },
      });
      $el.on('change.select2react', function () {
        filtroEmpresaRef.current = String($el.val() || '').trim();
      });
      return () => {
        if ($el.hasClass('select2-hidden-accessible')) {
          $el.off('change.select2react');
          $el.select2('destroy');
        }
      };
    } catch (e) {
      console.error('Error inicializando Select2 (empresa servicios):', e);
      return undefined;
    }
  }, [empresas]);

  useEffect(() => {
    try {
      const $ = window.$;
      if (!especialidadFiltroSelectRef.current || !$?.fn?.select2) {
        return undefined;
      }
      const $el = $(especialidadFiltroSelectRef.current);
      if ($el.hasClass('select2-hidden-accessible')) {
        $el.off('change.select2react');
        $el.select2('destroy');
      }
      $el.select2({
        placeholder: '-- Seleccione una especialidad --',
        allowClear: true,
        width: '100%',
        theme: 'default',
        minimumResultsForSearch: 0,
        language: {
          noResults: function () { return 'No se encontraron resultados'; },
          searching: function () { return 'Buscando...'; },
        },
      });
      $el.on('change.select2react', function () {
        const v = $el.val();
        const opt = $el.find('option:selected');
        if (!v) {
          filtroEspecialidadNombreRef.current = '';
        } else {
          filtroEspecialidadNombreRef.current = String(opt.text() || '').trim();
        }
      });
      return () => {
        if ($el.hasClass('select2-hidden-accessible')) {
          $el.off('change.select2react');
          $el.select2('destroy');
        }
      };
    } catch (e) {
      console.error('Error inicializando Select2 (especialidad servicios):', e);
      return undefined;
    }
  }, [especialidades]);

  // Función para cargar servicios bajo demanda (solo al presionar Consultar)
  const cargarServicios = async (nombre_empresa, nombre_especialidad) => {
    try {
      setCargando(true);
      const params = { nombre_empresa, nombre_especialidad };
      const response = await getAllServiciosApi(params);
      if (response.statusCode === 200 && response.result) {
        setServicios(response.result);
      } else {
        alert('No se pudieron cargar los servicios');
      }
    } catch (error) {
      console.error('Error al cargar servicios:', error);
      alert('Error al cargar los servicios: ' + (error.message || 'Error desconocido'));
    } finally {
      setCargando(false);
    }
  };

  const consultarServicios = async () => {
    const nombre_empresa = filtroEmpresaRef.current || '';
    const nombre_especialidad = filtroEspecialidadNombreRef.current || '';
    await cargarServicios(nombre_empresa, nombre_especialidad);
  };

  // Cambiar valores de una fila en el estado local (por id: índice de serviciosFiltrados no coincide con servicios)
  const cambiarValor = (servicioId, campo, nuevoValor) => {
    setServicios((prev) =>
      prev.map((row) =>
        row.id === servicioId
          ? {
              ...row,
              [campo]: nuevoValor === '' ? '' : parseInt(nuevoValor, 10) || 0,
            }
          : row
      )
    );
  };

  // Guardar cambios de una fila en el backend
  const guardarFila = async (servicioId) => {
    try {
      setProcesando(true);
      const fila = servicios.find((r) => r.id === servicioId);
      const id = fila?.id;
      if (!id) {
        alert('No se encontró el identificador del servicio');
        return;
      }
      const vp = fila?.valorPreviplan;
      const va = fila?.valorParticular;
      if ((vp !== '' && (isNaN(vp) || Number(vp) < 0)) || (va !== '' && (isNaN(va) || Number(va) < 0))) {
        alert('Valores inválidos: deben ser números mayores o iguales a 0');
        return;
      }
      await updateServicioApi(id, {
        valorPreviplan: vp === '' ? null : parseInt(vp),
        valorParticular: va === '' ? null : parseInt(va)
      });
      alert('Valores actualizados correctamente');
    } catch (err) {
      console.error('Error al actualizar servicio:', err);
      alert('Error al actualizar servicio: ' + (err?.message || ''));
    } finally {
      setProcesando(false);
    }
  };

  useEffect(() => {
    cargarEspecialidades();
    cargarEmpresas();
  }, []);

  const cargarEmpresas = async () => {
    try {
      const response = await getAllEmpresasApi();
      if (response.statusCode === 200 && Array.isArray(response.result)) {
        setEmpresas(response.result);
      }
    } catch (e) {
      console.error('Error al cargar empresas:', e);
    }
  };
  const cargarEspecialidades = async () => {
    try {
      setEspecialidades([]);
      const response = await viewEspecialidadesGroupApi();
      if (response.statusCode === 200 && Array.isArray(response.result)) {
        setEspecialidades(response.result);
      }
    } catch (e) {
      setEspecialidades([]);
      console.error('Error al cargar especialidades:', e);
    }
  };

  return (
    <div id="cajaPrincipal" style={cajaPrincipalStyle}>
      <LoadingOverlay visible={cargando || procesando} />
      <TituloAdmin
        titulo="Administración - Servicios"
        imagen_titulo="servi"
        subtitulo="Gestión de servicios médicos"
      />
      <div style={cajaContenedorAdminStyle}>

        <div id="divFiltrarServicios" style={{ width: '100%', display: 'flex', gap: '1vh', alignItems: 'flex-end', flexWrap: 'wrap' }}>

          <div style={{ width: '40vh', minWidth: 0, maxWidth: '100%' }}>
            <Label>Seleccione Empresa</Label>
            <select ref={empresaFiltroSelectRef} style={selectStyle} defaultValue="">
              <option value="">-- Seleccione una empresa --</option>
              {empresas.map((emp, idx) => (
                <option key={emp.id != null ? String(emp.id) : `emp-${idx}`} value={emp.nombre_empresa ?? ''}>
                  {emp.nombre_empresa ?? ''}
                </option>
              ))}
            </select>
          </div>

          <div style={{ width: '40vh', minWidth: 0, maxWidth: '100%' }}>
            <Label>Especialidad</Label>
            <select ref={especialidadFiltroSelectRef} style={selectStyle} defaultValue="">
              <option value="">-- Seleccione una especialidad --</option>
              {especialidades.map((esp, idx) => (
                <option
                  key={
                    esp.oid_especialidad != null && esp.oid_especialidad !== ''
                      ? String(esp.oid_especialidad)
                      : esp.id != null
                        ? String(esp.id)
                        : `esp-${idx}`
                  }
                  value={esp.oid_especialidad != null && esp.oid_especialidad !== '' ? String(esp.oid_especialidad) : ''}
                >
                  {esp.nombre_especialidad ?? ''}
                </option>
              ))}
            </select>
          </div>
          <div>
            <BotonBuscar
              onClick={consultarServicios}
              disabled={cargando}
              titulo="Consultar servicios con los filtros seleccionados"
              varianteFiltros={false}
            />
          </div>
        </div>
        {/* Fin caja divFiltrarServicios */}
        <div id="divTablaServicios" className="modern-table-container">
          <table id="tabla-servicios" className="modern-table">
            <thead>
              <tr>
                <th>CUP</th>
                <th>OID</th>
                <th>Servicio</th>
                <th>Especialidad</th>
                <th>Empresa</th>
                <th style={{ textAlign: 'center' }}>Valor Previplan</th>
                <th style={{ textAlign: 'center' }}>Valor Particular</th>
                <th style={{ textAlign: 'center' }}>Acción</th>
              </tr>
            </thead>
            <tbody>
              {!cargando && Array.isArray(servicios) && servicios.map((s, index) => (
                <tr key={s.id ?? s.sku ?? `${s.nombre_servicio || ''}-${index}`}>
                  <td>{s.sku ?? ''}</td>
                  <td>{s.oid_especialidad ?? ''}</td>
                  <td>{s.nombre_servicio ?? ''}</td>
                  <td>{s.nombre_especialidad ?? ''}</td>
                  <td>{s.nombre_empresa ?? ''}</td>
                  <td style={{ textAlign: 'center' }}>
                    <input
                      type="number"
                      min="0"
                      value={s.valorPreviplan ?? 0}
                      onChange={(e) => cambiarValor(s.id, 'valorPreviplan', e.target.value)}
                      style={{
                        width: '100px',
                        height: '3.5vh',
                        padding: '0.3rem 0.5rem',
                        border: `1px solid ${colors.gray200}`,
                        borderRadius: '4px',
                        fontSize: '1.8vh',
                        fontFamily: 'Inter',
                        textAlign: 'center',
                        fontWeight: '600',
                        backgroundColor: colors.white
                      }}
                      disabled={procesando}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      value={s.valorParticular ?? 0}
                      onChange={(e) => cambiarValor(s.id, 'valorParticular', e.target.value)}
                      style={{
                        width: '100px',
                        height: '3.5vh',
                        padding: '0.3rem 0.5rem',
                        border: `1px solid ${colors.gray200}`,
                        borderRadius: '4px',
                        fontSize: '1.8vh',
                        fontFamily: 'Inter',
                        textAlign: 'center',
                        fontWeight: '600',
                        backgroundColor: colors.white
                      }}
                      disabled={procesando}
                    />
                  </td>
                  <td>
                    <button
                      onClick={() => guardarFila(s.id)}
                      disabled={procesando}
                      style={{
                        backgroundColor: colors.accent,
                        color: colors.white,
                        border: 'none',
                        borderRadius: '6px',
                        padding: '0.5rem 1rem',
                        fontSize: '1.3vh',
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        cursor: procesando ? 'not-allowed' : 'pointer'
                      }}
                    >
                      {procesando ? 'Guardando...' : 'Actualizar'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Fin caja divTablaServicios */}
        <div style={{ width: '100%', marginTop: '3vh' }}>
          {cargando && (
            <LabelCarga nombre={"servicios"} />
          )}
        </div>
      </div>
      {/* Fin caja contenidoAdmin */}
    </div>
  );
}

export default Serviciosadmin;